/// <amd-module name="Feed/Legacy/Helpers/PackageMetricsHelper" />
import { find } from "OfficeFabric/Utilities";

import { PackageMetrics, PackageVersionMetrics } from "Feed/Common/Contracts/Feed";

import { IFeedDataService } from "../DataServices/FeedsDataService";

export function getEmptyMetrics(packageId: string): PackageMetrics {
    return {
        downloadCount: 0,
        downloadUniqueUsers: 0,
        lastDownloaded: null,
        packageId: packageId
    } as PackageMetrics;
}

export function getEmptyVersionMetrics(packageId: string, packageVersionId: string): PackageVersionMetrics {
    return {
        downloadCount: 0,
        downloadUniqueUsers: 0,
        lastDownloaded: null,
        packageId: packageId,
        packageVersionId: packageVersionId
    } as PackageVersionMetrics;
}

export async function getPackageMetricsAsync(
    projectId: string,
    feedId: string,
    packageIds: string[],
    feedsDataService: IFeedDataService
): Promise<{ [key: string]: PackageMetrics }> {
    const requestedMetrics = await feedsDataService.queryPackageMetricsAsync(projectId, feedId, packageIds);
    let outMetricsMap: { [key: string]: PackageMetrics } = {};
    // Convert array of metrics into map of package ID => metrics
    packageIds.forEach((packageId: string) => {
        outMetricsMap[packageId] =
            find(requestedMetrics, (packageMetric: PackageMetrics) => packageMetric.packageId === packageId) ||
            getEmptyMetrics(packageId);
    });

    return outMetricsMap;
}

export async function getPackageVersionMetricsAsync(
    projectId: string,
    feedId: string,
    packageId: string,
    packageVersionIds: string[],
    feedsDataService: IFeedDataService
): Promise<{ [key: string]: PackageVersionMetrics }> {
    const requestedVersionMetrics = await feedsDataService.queryPackageVersionMetricsAsync(
        projectId,
        feedId,
        packageId,
        packageVersionIds
    );
    let outMetricsMap: { [key: string]: PackageVersionMetrics } = {};
    // Convert array of metrics into map of version ID => metrics
    packageVersionIds.forEach((packageVersionId: string) => {
        outMetricsMap[packageVersionId] =
            find(
                requestedVersionMetrics,
                (packageVersionMetric: PackageVersionMetrics) =>
                    packageVersionMetric.packageVersionId === packageVersionId
            ) || getEmptyVersionMetrics(packageId, packageVersionId);
    });

    return outMetricsMap;
}
